import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";
import toastError from "../../errors/toastError";
import api from "../../services/api";

const useStyles = makeStyles(theme => ({
	chip: {
		margin: 1,
		maxWidth: "100%",
		height: "auto",
		borderRadius: "12px",
		boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
		"& .MuiChip-label": {
			whiteSpace: "normal",
			wordBreak: "break-word",
			lineHeight: "1.2",
			padding: "6px 10px",
			fontSize: "0.8rem",
			fontWeight: "500",
			color: "white",
		},
	},
	selectContainer: {
		"& .MuiSelect-select": {
			minHeight: "50px",
			display: "flex",
			alignItems: "flex-start",
			padding: "8px 12px",
			borderRadius: "8px",
		},
		"& .MuiOutlinedInput-root": {
			borderRadius: "8px",
		},
	},
	menuItem: {
		padding: "8px 16px",
		"&:hover": {
			backgroundColor: "#f5f5f5",
		},
	},
	menuItemSelected: {
		backgroundColor: "#e3f2fd !important",
		color: "#1976d2",
		fontWeight: "500",
		"&:hover": {
			backgroundColor: "#bbdefb !important",
		},
	},
	menuItemIcon: {
		marginRight: "8px",
		fontSize: "16px",
	},
	placeholder: {
		color: "#999",
		fontStyle: "italic",
		fontSize: "0.9rem",
	},
}));

const PromptSelect = ({ selectedPromptId, onChange, title = "Prompt (Opcional)", disabled = false }) => {
	const classes = useStyles();
	const [prompts, setPrompts] = useState([]);

	useEffect(() => {
		fetchPrompts();
	}, []);

	const fetchPrompts = async () => {
		try {
			const { data } = await api.get("/prompt");
			setPrompts(data.prompts || []);
		} catch (err) {
			toastError(err);
		}
	}

	const handleChange = e => {
		// ✅ Asegurar que onChange reciba el evento completo para compatibilidad
		onChange(e);
	};

	return (
		<div>
			<FormControl fullWidth margin="dense" variant="outlined" className={classes.selectContainer}>
				<InputLabel shrink={selectedPromptId ? true : false}>{title}</InputLabel>
				<Select
					label={title}
					labelWidth={60}
					value={selectedPromptId || ''}
					onChange={handleChange}
					disabled={disabled}
					MenuProps={{
						anchorOrigin: {
							vertical: "bottom",
							horizontal: "left",
						},
						transformOrigin: {
							vertical: "top",
							horizontal: "left",
						},
						getContentAnchorEl: null,
					}}
					renderValue={selected => {
						if (!selected || selected === null || selected === undefined || selected === '') {
							return <span className={classes.placeholder}>Seleccionar prompt...</span>;
						}
						
						const prompt = prompts.find(p => p.id === selected);
						
						if (prompt && prompt.name) {
							return (
								<Chip
									variant="outlined"
									style={{ backgroundColor: "#1976d2" }}
									label={prompt.name}
									className={classes.chip}
								/>
							);
						} else {
							return <span className={classes.placeholder}>Seleccionar prompt...</span>;
						}
					}}
				>
					<MenuItem value="">
						<span className={classes.placeholder}>Ninguna</span>
					</MenuItem>
					{prompts.map(prompt => {
						const isSelected = selectedPromptId === prompt.id;
						
						return (
							<MenuItem 
								key={prompt.id} 
								value={prompt.id}
								className={isSelected ? classes.menuItemSelected : classes.menuItem}
							>
								<span className={classes.menuItemIcon}>
									{isSelected ? '✓' : '○'}
								</span>
								{prompt.name}
								{isSelected && (
									<span style={{ marginLeft: 'auto', fontSize: '0.8rem', color: '#1976d2' }}>
										Seleccionado
									</span>
								)}
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>
		</div>
	);
};

export default PromptSelect;
